import { Injectable } from '@angular/core';
import { Observable, Subject, forkJoin } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { LocalStorageService } from '../services/localStorage.service';
import * as $ from 'jquery';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DvmpService {
  filename = 'assets/files/treatements_en.json';
  holidayfile = 'assets/files/holidays.json';
  url = 'https://www.googleapis.com/calendar/v3/calendars/es.spain%23holiday%40group.v.calendar.google.com/events?key=AIzaSyCBKXUBaLkrin3K0NBuAcQ9YkPKni5QPjk';
  count = 0;
  hoildaysUrl: string;
  DoseDividaDefaults: Array<any>;
  updatedEvents = new Subject<any>();
  weekend = false;
  enddate: Date;
  locale_code: string;
  treatsArray = [];
  colors = [];
  drugs = [];
  holidays = [];
  country = '';
  language = 'EN';
  calLangCode = 'EN';
  enableInputTextboxes: boolean;
  SMPCDefintionDropdowns: boolean;
  DragnDropWithPopup: boolean;
  optedTreatments = {
    DVMP: false,
    DVD: true,
    DRD: true,
    D: true
  };
  formulation: boolean;

  constructor(private _http: HttpClient, private _localstorage: LocalStorageService) { }

  public getDvmp(locale): Observable<any> {
    return this._http.get(`assets/files/treatements_${locale}.json`);
  }

  public getholidayfromfile(): Observable<any> {
    return this._http.get(this.holidayfile);

  }

  public getholidayfromAPI(year): Observable<any> {
    const params = new HttpParams()
      .set('country', this.country)
      .set('year', year)
      .set('language', this.language);
    return this._http
      .get(`https://calendarific.com/api/v2/holidays?&api_key=e1ca35ee0ba75e821aa682f94eb006af0c0b5925`, { params });
  }

  getHolidaysFromAPI(curentYear) {
    console.log('fething holidays list');
    const currentYearRes = this.getholidayfromAPI(curentYear);
    const nextYearRes = this.getholidayfromAPI(curentYear + 1);

    const combinedRes = forkJoin([currentYearRes, nextYearRes]).pipe(
      map(([first, second]) => {
        if (first.meta.error_type === undefined) {
          return [...first.response.holidays, ...second.response.holidays];
        }
      })
    );

    combinedRes.subscribe(res => {
      if (res !== undefined) {
        this.holidays = res;
      }
    });
  }
  seeCal() {
    console.log('holidays started loading');
    const patientData = JSON.parse(localStorage.getItem('patientdetails'));
    const curentYear = new Date(patientData['Fechaactual']).getFullYear();
    if (this.holidays.length > 0) {
      const existingHolidays = this.holidays;
      const existingYears = Array.from(new Set(existingHolidays.map(hday => {
        return hday.date.datetime.year;
      })));
      existingYears.includes(curentYear) && existingYears.includes(curentYear + 1) ?
        console.log('holidays from local') : this.getHolidaysFromAPI(curentYear);
      if (this.holidays.length === 0) {
        alert('language code for this country is wrong');
      }
    } else {
      this.getHolidaysFromAPI(curentYear);
    }
  }

  public GetDefaultValues(): Array<any> {
    return this.DoseDividaDefaults;
  }


  public setDoseDividaDefaults(Deafults) {
    this.DoseDividaDefaults = Deafults;
  }

  getUpdatedEvents(): Observable<any> {
    return this.updatedEvents.asObservable();
  }



  public Checkdefaultvalue(ccycle, arry, Dvalues) {

    const patientdetails = JSON.parse(this._localstorage.getItem('patientdetails'));
    const dosedivida = JSON.parse(this._localstorage.getItem('DoseDivide'));
    const indexvalue = ccycle - patientdetails.Cicle;
    let defaultArray = [];

    if (dosedivida && ccycle === 1) {
      defaultArray = this.DoseDividaDefaults;
      console.log(defaultArray, 'maaaa');
    } else {
      // defaultArray = Dvalues[indexvalue].default;
      Dvalues.forEach(val => {
        if (val.cycle === ccycle) {
          defaultArray = val.default;
        }
      });
    }

    let indexValue = false;
    for (let index = 0; index < defaultArray.length; index++) {

      if (defaultArray[index].replace(/ /g, '') !== arry[index].replace(/ /g, '')) {
        indexValue = true;
      }

    }
    if (indexValue === true) {
      $('#ErrorCycle' + ccycle).html($localize`:@@cycleChangeWarning:Cycle change warning en`);
    } else {
      $('#ErrorCycle' + ccycle).html('');
    }
  }


  public ClearErrorDisclimer() {
    $('.ErrorCycle').html('');

  }


  public GetTotalNumberOfDays(DropdownValues): number {
    const Values = DropdownValues.map((item) => item.default);
    const Maxvalue = [];
    Values.forEach(element => {
      const Maxpercycle = [];
      element.forEach(item => {
        const regExp = /\(([^)]+)\)/;
        const matches = regExp.exec(item);
        if (matches) {
          const numberPattern = /\d+/g;
          Maxpercycle.push(parseInt(matches[1].match(numberPattern).toString(), 10));
        }
      });
      Maxvalue.push(Math.max.apply(Math, Maxpercycle));

    });

    const Numberofdays = Maxvalue.reduce((acc, val) => acc + val);


    return Numberofdays;
  }


  public setNonBussinessday(item) {
    this.weekend = item;
  }

  public getNonBussinessday(): boolean {
    return this.weekend;
  }
  public setEnddate(date) {
    this.enddate = date;
  }

  public getEnddate() {
    return this.enddate;
  }

  // public getHolidays(): Observable<any>{
  // this.hoildaysUrl= "https://www.googleapis.com/calendar/v3/calendars/
  // es.spain%23holiday%40group.v.calendar.google.com/events?key="
  //   console.log(++this.count)
  //   return this._http.get(this.hoildaysUrl);

  // }

}
